import { ServiceType } from "@domain/enums/machine.enums";
import type { ColorOption } from "@infrastructure/stores/serviceMetadata.store";
import { ServiceMetadataStore } from "@infrastructure/stores/serviceMetadata.store";

export interface ServiceInfo {
  title: string;
  description: string;
  price: string;
  enabled: boolean;
  hint: string | null;
  iconUrl: string | null;
  formatOptions: string[];
  colorOptions: ColorOption[];
  duplexAvailable: boolean;
  offlineAvailable: boolean;
  comingSoon: boolean;
}

const EMPTY: ServiceInfo = {
  title: "",
  description: "",
  price: "",
  enabled: false,
  hint: null,
  iconUrl: null,
  formatOptions: [],
  colorOptions: [],
  duplexAvailable: false,
  offlineAvailable: false,
  comingSoon: false,
};

export const getOrderedServiceTypes = (): ServiceType[] => {
  return ServiceMetadataStore.getOrderedServicesWithDisabledLast().map(
    (s) => s.serviceType as ServiceType
  );
};

export const getInfoByService = (type: ServiceType): ServiceInfo => {
  const fromStore = ServiceMetadataStore.getByType(type);
  if (fromStore) {
    return {
      title: fromStore.name,
      description: fromStore.description,
      price: fromStore.priceLabel,
      enabled: fromStore.enabled,
      hint: fromStore.hint,
      iconUrl: fromStore.iconUrl,
      formatOptions: fromStore.formatOptions,
      colorOptions: fromStore.colorOptions,
      duplexAvailable: fromStore.duplexAvailable,
      offlineAvailable: fromStore.offlineAvailable,
      comingSoon: fromStore.comingSoon,
    };
  }
  return EMPTY;
};
